import { render, staticRenderFns } from "./ActivateClub.vue?vue&type=template&id=ef53bc86&scoped=true&"
import script from "./ActivateClub.vue?vue&type=script&lang=js&"
export * from "./ActivateClub.vue?vue&type=script&lang=js&"
import style0 from "./ActivateClub.vue?vue&type=style&index=0&id=ef53bc86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef53bc86",
  null
  
)

export default component.exports